var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-state"},[_c('p',[_vm._v("."+_vm._s(_vm.previewType)+"文件类型无法预览")]),_c('p',[_vm._v("建议下载至本地查看")])])}
var staticRenderFns = []

export { render, staticRenderFns }